import { createRouter, createWebHistory } from "vue-router";
import Default from "../views/dashboards/Default.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboards/dashboard-default",
  },
  {
    path: "/dashboards/dashboard-default",
    name: "Default",
    component: Default,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/dashboards/dashboard-default",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
